import { SuggestedEntry } from 'app/copied/models/ChatModules';
import useNamespacedStorage from 'app/hooks/storage/useNamespacedStorage';

export default function useArticles() {
  const [articles, setArticles] = useNamespacedStorage<SuggestedEntry[]>('tailor-articles', []);

  const addArticle = (article: SuggestedEntry) => {
    const isUnique = !articles.some((existingArticle: SuggestedEntry) => existingArticle.id === article.id);
    if (isUnique) {
      setArticles([...articles, article]);
    }
  };

  return {
    articles,
    addArticle,
  };
}
